import { defineStore } from "pinia";
import http from "@/http";
import {
  LIST_EQUIPAMENTO,
  ADD_EQUIPAMENTO,
  UPDATE_EQUIPAMENTO,
  DEL_EQUIPAMENTO,
  LIST_SERVICO,
  ADD_SERVICO,
  UPDATE_SERVICO,
  DEL_SERVICO,
} from "@/http/url";

export const useEquipamentoStore = defineStore("EquipamentoStore", {
  state: () => {
    return {
      equipamentos: [],
      servicos: [],
      loaded: false,
    };
  },

  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_EQUIPAMENTOS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_EQUIPAMENTO)
          .then((response) => {
            this.equipamentos = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_EQUIPAMENTO(equipamento) {
      return http
        .post(ADD_EQUIPAMENTO, equipamento)
        .then((response) => this.equipamentos.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_EQUIPAMENTO(equipamento) {
      return http
        .put(`${UPDATE_EQUIPAMENTO + equipamento.sgcq}`, equipamento)
        .then((response) => {
          const index = this.equipamentos.findIndex((objeto) => objeto.sgcq === response.data.sgcq);
          this.equipamentos[index] = response.data;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    REMOVER_EQUIPAMENTO(sgcq) {
      return http
        .delete(`${DEL_EQUIPAMENTO + sgcq}`)
        .then(() => (this.equipamentos = this.equipamentos.filter((eqp) => eqp.sgcq != sgcq)));
    },

    LISTAR_SERVICOS(sgcq) {
      return new Promise((resolve, reject) => {
        http
          .get(`${LIST_SERVICO + sgcq}`)
          .then((response) => {
            this.servicos = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_SERVICO(servico) {
      return http.post(ADD_SERVICO, servico).catch((erro) => {
        console.log(erro);
      });
    },

    ALTERAR_SERVICO(servico) {
      return http.put(`${UPDATE_SERVICO + servico.id}`, servico);
    },

    REMOVER_SERVICO(id) {
      return http
        .delete(`${DEL_SERVICO + id}`)
        .then(() => (this.servicos = this.servicos.filter((serv) => serv.id != id)));
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getEquipamentos() {
      return this.equipamentos;
    },

    getBySgcq: (state) => {
      return (sgcq) => {
        return state.equipamentos.filter((equip) => !sgcq || equip.sgcq == sgcq);
      };
    },

    getEquipamentoLoad(state) {
      return state.loaded;
    },

    getServicos(state) {
      return state.servicos;
    },

    getLastServico(state) {
      return state.servicos.slice(-1);
    },

    getFilterEquipamentos: (state) => {
      return (filtro) => {
        let filtrada = state.equipamentos;

        if (filtro.sgcq != "") {
          filtrada = filtrada.filter((e) => !filtro || e.sgcq == filtro.sgcq);
        }

        if (filtro.cliente.id != 0) {
          filtrada = filtrada.filter((e) => !filtro || e.cliente.id == filtro.cliente.id);
        }

        filtrada = filtrada.filter(
          (e) =>
            !filtro ||
            (e.nome.includes(filtro.nome) &&
              e.codigo.includes(filtro.codigo) &&
              e.grupo.includes(filtro.grupo) &&
              e.referencia.includes(filtro.referencia))
        );

        return filtrada;
      };
    },
  },
});
